import * as z from 'zod/v4';

export const alignProposalTransportTimewindowSchema = z.object({
    transportTimewindowId: z.string(),
    start: z.string(),
    end: z.string(),
    serviceIdentifier: z.string(),
});

export type AlignProposalTransportTimewindow = z.infer<typeof alignProposalTransportTimewindowSchema>;

export const alignProposalServiceLineSchema = z.object({
    capacityNeeded: z.number(),
    capacityUnit: z.string(),
    serviceNo: z.string(),
    serviceCode: z.string(),
    serviceProviderId: z.string(),
    timeWindowId: z.string(),
    manualChangeType: z.enum(['STARTTIME', 'NO_CHANGE']),
    fromDate: z.string(),
    transportTimewindows: z.array(alignProposalTransportTimewindowSchema),
});

export type AlignProposalServiceLine = z.infer<typeof alignProposalServiceLineSchema>;

export const alignProposalPayloadSchema = z.object({
    locality: z.string(),
    serviceLines: z.array(alignProposalServiceLineSchema),
});

export type AlignProposalPayload = z.infer<typeof alignProposalPayloadSchema>;

export const alignProposalTimeWindowSchema = z.object({
    id: z.string(),
    capacityAllocated: z.number(),
    sequence: z.number(),
    fromDateTime: z.string(),
    toDateTime: z.string(),
    timeZone: z.string(),
});

export type AlignProposalTimeWindow = z.infer<typeof alignProposalTimeWindowSchema>;

export const alignProposalServiceSuccessSchema = z.object({
    serviceNo: z.string(),
    serviceCode: z.string(),
    sequence: z.number(),
    hasValidated: z.boolean().optional(),
    serviceProviderId: z.string(),
    serviceProviderName: z.string().optional(),
    timeWindows: z.array(alignProposalTimeWindowSchema),
    errorCode: z.undefined().optional(),
    errorDescription: z.undefined().optional(),
});

export type AlignProposalServiceSuccess = z.infer<typeof alignProposalServiceSuccessSchema>;

export const alignProposalServiceErrorSchema = z.object({
    serviceNo: z.string(),
    serviceCode: z.string(),
    sequence: z.number(),
    hasValidated: z.boolean().optional(),
    serviceProviderId: z.string().optional(),
    serviceProviderName: z.string().optional(),
    timeWindows: z.array(alignProposalTimeWindowSchema).optional(),
    errorCode: z.string(),
    errorDescription: z.string().optional(),
});

export type AlignProposalServiceError = z.infer<typeof alignProposalServiceErrorSchema>;

export const alignProposalServiceSchema = z.union([alignProposalServiceSuccessSchema, alignProposalServiceErrorSchema]);

export type AlignProposalService = z.infer<typeof alignProposalServiceSchema>;

export const isAlignProposalServiceError = (service: AlignProposalService): service is AlignProposalServiceError =>
    service.errorCode !== undefined;

export const isAlignProposalServiceSuccess = (service: AlignProposalService): service is AlignProposalServiceSuccess =>
    !isAlignProposalServiceError(service);

export const alignProposalResponseSchema = z.object({
    services: z.array(alignProposalServiceSchema),
});

export type AlignProposalResponse = z.infer<typeof alignProposalResponseSchema>;
